import React, { HTMLAttributes } from 'react';
import { IconType } from 'react-icons';
import * as styles from '../../styles/icons/combinedIconTopRight.module.scss';

type Props = HTMLAttributes<HTMLSpanElement> & {
  className: string;
  colorSmall: string;
  MainIcon: IconType;
  SmallIcon: IconType;
};

const CombinedIconTopRight: React.FC<Props> = (props) => {
  const { className, colorSmall, MainIcon, SmallIcon } = props;
  const containerClass = `${styles.container} ${className || ''}`;
  const smallIconClass = `${styles.small_icon} ${styles[colorSmall]}`;

  const sanitizedProps: Partial<Props> = {
    ...props,
  };

  delete sanitizedProps.colorSmall;
  delete sanitizedProps.MainIcon;
  delete sanitizedProps.SmallIcon;

  return (
    <span {...sanitizedProps} className={containerClass}>
      <MainIcon />
      <SmallIcon className={smallIconClass} />
    </span>
  );
};

export default CombinedIconTopRight;
